/**
 * ELSTER StaatId, the country codes a foreign address may carry in the KapG
 * questionnaire (Zeile 76a and Zeile 30).
 *
 * GENERATED from `Enum_StaatId_Schluesselwerte_3_BaseSType` in
 * `FsE_KapG-202401.xsd` (ERiC 44.2.4.1, FsE_KapG 202401), in schema order.
 * Regenerate from the XSD rather than editing this file: a code that is not in
 * the enumeration is only rejected by ERiC, after the operator has left the
 * form.
 *
 * The labels are ELSTER's own German country names and are used in both
 * Backoffice languages, because that is the term the operator matches against
 * Mein ELSTER.
 */
export const KAPG_COUNTRY_OPTIONS: ReadonlyArray<{
  value: string;
  label: string;
}> = [
  { value: "660", label: "Afghanistan" },
  { value: "220", label: "Ägypten" },
  { value: "070", label: "Albanien" },
  { value: "208", label: "Algerien" },
  { value: "832", label: "Amerik. Überseeinseln" },
  { value: "830", label: "Amerik.-Samoa" },
  { value: "457", label: "Amerikan. Jungferninseln" },
  { value: "043", label: "Andorra" },
  { value: "330", label: "Angola" },
  { value: "446", label: "Anguilla" },
  { value: "891", label: "Antarktis" },
  { value: "459", label: "Antigua und Barbuda" },
  { value: "310", label: "Äquatorialguinea" },
  { value: "608", label: "Arabische Republik Syrien" },
  { value: "528", label: "Argentinien" },
  { value: "077", label: "Armenien" },
  { value: "474", label: "Aruba" },
  { value: "078", label: "Aserbaidschan" },
  { value: "334", label: "Äthiopien" },
  { value: "800", label: "Australien" },
  { value: "802", label: "Australisch-Ozeanien" },
  { value: "453", label: "Bahamas" },
  { value: "640", label: "Bahrain" },
  { value: "666", label: "Bangladesch" },
  { value: "469", label: "Barbados" },
  { value: "073", label: "Belarus (Weißrussland)" },
  { value: "017", label: "Belgien" },
  { value: "421", label: "Belize" },
  { value: "284", label: "Benin (ehem. Dahome)" },
  { value: "413", label: "Bermuda" },
  { value: "625", label: "Besetzte palästinensische Gebiete" },
  { value: "675", label: "Bhutan" },
  { value: "516", label: "Bolivien" },
  { value: "475", label: "Bonaire" },
  { value: "093", label: "Bosnien und Herzegowina" },
  { value: "391", label: "Botsuana" },
  { value: "892", label: "Bouvet-Inseln" },
  { value: "508", label: "Brasilien" },
  { value: "468", label: "Brit. Jungferninseln" },
  { value: "357", label: "Brit. Territorium im Ind. Ozean" },
  { value: "703", label: "Brunei Darussalam" },
  { value: "068", label: "Bulgarien" },
  { value: "236", label: "Burkina Faso (ehem. Obervolta)" },
  { value: "328", label: "Burundi" },
  { value: "021", label: "Ceuta" },
  { value: "512", label: "Chile" },
  { value: "720", label: "China" },
  { value: "837", label: "Cook-Inseln" },
  { value: "436", label: "Costa Rica" },
  { value: "272", label: "Cote D'Ivoire (Elfenbeinküste)" },
  { value: "477", label: "Curacao" },
  { value: "008", label: "Dänemark" },
  { value: "724", label: "Dem. VR Korea (Nordkorea)" },
  { value: "322", label: "Demokr. Rep. Kongo (Ehem. Zaire)" },
  { value: "460", label: "Dominica" },
  { value: "456", label: "Dominikanische Republik" },
  { value: "338", label: "Dschibuti" },
  { value: "500", label: "Ecuador" },
  { value: "096", label: "Ehem. jugoslawische Rep. Mazedonien" },
  { value: "428", label: "El Salvador" },
  { value: "336", label: "Eritrea" },
  { value: "053", label: "Estland" },
  { value: "529", label: "Falklandinseln" },
  { value: "041", label: "Färöer" },
  { value: "815", label: "Fidschi" },
  { value: "032", label: "Finnland" },
  { value: "823", label: "Föderierte Staaten von Mikronesien" },
  { value: "001", label: "Frankreich" },
  { value: "894", label: "Französische Südgebiete" },
  { value: "822", label: "Frz. Polynesien" },
  { value: "314", label: "Gabun" },
  { value: "252", label: "Gambia" },
  { value: "076", label: "Georgien" },
  { value: "276", label: "Ghana" },
  { value: "044", label: "Gibraltar" },
  { value: "473", label: "Grenada" },
  { value: "009", label: "Griechenland" },
  { value: "406", label: "Grönland" },
  { value: "831", label: "Guam" },
  { value: "416", label: "Guatemala" },
  { value: "107", label: "Guernsey" },
  { value: "260", label: "Guinea" },
  { value: "257", label: "Guinea-Bissau" },
  { value: "488", label: "Guyana" },
  { value: "452", label: "Haiti" },
  { value: "835", label: "Heard und McDonald-Inseln" },
  { value: "424", label: "Honduras" },
  { value: "740", label: "Hongkong" },
  { value: "664", label: "Indien" },
  { value: "700", label: "Indonesien" },
  { value: "109", label: "Insel Man" },
  { value: "612", label: "Irak" },
  { value: "007", label: "Irland" },
  { value: "616", label: "Islamische Republik Iran" },
  { value: "024", label: "Island" },
  { value: "624", label: "Israel" },
  { value: "005", label: "Italien" },
  { value: "464", label: "Jamaika" },
  { value: "732", label: "Japan" },
  { value: "653", label: "Jemen" },
  { value: "108", label: "Jersey" },
  { value: "628", label: "Jordanien" },
  { value: "463", label: "Kaimaninseln" },
  { value: "696", label: "Kambodscha" },
  { value: "302", label: "Kamerun" },
  { value: "404", label: "Kanada" },
  { value: "247", label: "Kap Verde" },
  { value: "079", label: "Kasachstan" },
  { value: "644", label: "Katar" },
  { value: "346", label: "Kenia" },
  { value: "083", label: "Kirgisistan" },
  { value: "812", label: "Kiribati" },
  { value: "833", label: "Kokosinseln (Keeling-Inseln)" },
  { value: "480", label: "Kolumbien" },
  { value: "375", label: "Komoren" },
  { value: "095", label: "Kosovo" },
  { value: "092", label: "Kroatien" },
  { value: "448", label: "Kuba" },
  { value: "636", label: "Kuwait" },
  { value: "684", label: "Laos" },
  { value: "395", label: "Lesotho" },
  { value: "054", label: "Lettland" },
  { value: "604", label: "Libanon" },
  { value: "268", label: "Liberia" },
  { value: "216", label: "Libyen" },
  { value: "037", label: "Liechtenstein" },
  { value: "055", label: "Litauen" },
  { value: "018", label: "Luxemburg" },
  { value: "743", label: "Macau" },
  { value: "370", label: "Madagaskar" },
  { value: "386", label: "Malawi" },
  { value: "701", label: "Malaysia" },
  { value: "667", label: "Malediven" },
  { value: "232", label: "Mali" },
  { value: "046", label: "Malta" },
  { value: "204", label: "Marokko" },
  { value: "824", label: "Marshall-Inseln" },
  { value: "228", label: "Mauretanien" },
  { value: "373", label: "Mauritius" },
  { value: "377", label: "Mayotte" },
  { value: "023", label: "Melilla" },
  { value: "412", label: "Mexiko" },
  { value: "147", label: "Monaco" },
  { value: "716", label: "Mongolei" },
  { value: "097", label: "Montenegro" },
  { value: "470", label: "Montserrat" },
  { value: "366", label: "Mosambik" },
  { value: "676", label: "Myanmar" },
  { value: "389", label: "Namibia" },
  { value: "803", label: "Nauru" },
  { value: "672", label: "Nepal" },
  { value: "809", label: "Neukaledonien" },
  { value: "804", label: "Neuseeland" },
  { value: "814", label: "Neuseeländisch-Ozeanien" },
  { value: "432", label: "Nicaragua" },
  { value: "858", label: "nicht ermittelte Länder und Gebiete" },
  { value: "003", label: "Niederlande" },
  { value: "240", label: "Niger" },
  { value: "288", label: "Nigeria" },
  { value: "838", label: "Niue-Insel" },
  { value: "820", label: "Nördliche Marianen" },
  { value: "836", label: "Norfolk-Insel" },
  { value: "028", label: "Norwegen" },
  { value: "649", label: "Oman" },
  { value: "038", label: "Österreich" },
  { value: "662", label: "Pakistan" },
  { value: "825", label: "Palau" },
  { value: "442", label: "Panama" },
  { value: "801", label: "Papua-Neuguinea" },
  { value: "520", label: "Paraguay" },
  { value: "504", label: "Peru" },
  { value: "708", label: "Philippinen" },
  { value: "813", label: "Pitcairn" },
  { value: "890", label: "Polargebiete" },
  { value: "060", label: "Polen" },
  { value: "010", label: "Portugal (incl. Azoren + Madeira)" },
  { value: "318", label: "Republik Kongo" },
  { value: "728", label: "Republik Korea (Südkorea)" },
  { value: "074", label: "Republik Moldau (Moldawien)" },
  { value: "324", label: "Ruanda" },
  { value: "066", label: "Rumänien" },
  { value: "075", label: "Russische Föderation" },
  { value: "499", label: "Saba" },
  { value: "806", label: "Salomonen" },
  { value: "378", label: "Sambia" },
  { value: "819", label: "Samoa" },
  { value: "810", label: "Samoa, Amerik." },
  { value: "047", label: "San Marino" },
  { value: "311", label: "Sao Tome und Principe" },
  { value: "632", label: "Saudi-Arabien" },
  { value: "030", label: "Schweden" },
  { value: "039", label: "Schweiz" },
  { value: "248", label: "Senegal" },
  { value: "098", label: "Serbien" },
  { value: "094", label: "Serbien und Montenegro" },
  { value: "355", label: "Seychellen" },
  { value: "264", label: "Sierra Leone" },
  { value: "382", label: "Simbabwe" },
  { value: "706", label: "Singapur" },
  { value: "498", label: "Sint Eustatius" },
  { value: "479", label: "Sint Maarten" },
  { value: "063", label: "Slowakei" },
  { value: "091", label: "Slowenien" },
  { value: "342", label: "Somalia" },
  { value: "011", label: "Spanien" },
  { value: "669", label: "Sri Lanka" },
  { value: "329", label: "St. Helena" },
  { value: "449", label: "St. Kitts und Nevis" },
  { value: "465", label: "St. Lucia" },
  { value: "408", label: "St. Pierre und Miquelon" },
  { value: "467", label: "St. Vincent und die Grenadinen" },
  { value: "388", label: "Südafrika" },
  { value: "224", label: "Sudan" },
  { value: "893", label: "Südgeorgien u. südl. Sandwichinseln" },
  { value: "225", label: "Süd-Sudan" },
  { value: "492", label: "Suriname" },
  { value: "393", label: "Swasiland" },
  { value: "082", label: "Tadschikistan" },
  { value: "736", label: "Taiwan" },
  { value: "680", label: "Thailand" },
  { value: "626", label: "Timor-Leste" },
  { value: "280", label: "Togo" },
  { value: "839", label: "Tokelau" },
  { value: "817", label: "Tonga" },
  { value: "472", label: "Trinidad und Tobago" },
  { value: "244", label: "Tschad" },
  { value: "061", label: "Tschechische Republik" },
  { value: "212", label: "Tunesien" },
  { value: "052", label: "Türkei" },
  { value: "080", label: "Turkmenistan" },
  { value: "454", label: "Turks- und Caicosinseln" },
  { value: "807", label: "Tuvalu" },
  { value: "350", label: "Uganda" },
  { value: "072", label: "Ukraine" },
  { value: "064", label: "Ungarn" },
  { value: "524", label: "Uruguay" },
  { value: "400", label: "USA" },
  { value: "081", label: "Usbekistan" },
  { value: "816", label: "Vanuatu" },
  { value: "045", label: "Vatikanstadt" },
  { value: "484", label: "Venezuela" },
  { value: "647", label: "Vereinigte Arabische Emirate" },
  { value: "352", label: "Vereinigte Republik Tansania" },
  { value: "006", label: "Vereinigtes Königreich" },
  { value: "690", label: "Vietnam" },
  { value: "811", label: "Wallis und Futuna" },
  { value: "834", label: "Weihnachtsinsel (Ind. Ozean)" },
  { value: "306", label: "Zentralafrikanische Republik" },
  { value: "600", label: "Zypern" },
];
